// extracted by mini-css-extract-plugin
export default {"header":"style_header__1IvJU","menu-button":"style_menu-button__aWDsl","offset-on-mobile":"style_offset-on-mobile__QMtDZ"};